(() => {
  'use strict';
  function init(root) {
    if (root.dataset.chatReady) return;
    root.dataset.chatReady = 'true';
    const open = root.querySelector('[data-chat-open]');
    const close = root.querySelector('[data-chat-close]');
    const dialog = root.querySelector('dialog');
    if (!open || !close || !dialog || typeof dialog.showModal !== 'function') return;
    open.hidden = false;
    open.addEventListener('click', () => {
      if (dialog.open) return;
      dialog.showModal();
      open.setAttribute('aria-expanded', 'true');
      close.focus({preventScroll:true});
    });
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => {
      open.setAttribute('aria-expanded', 'false');
      open.focus({preventScroll:true});
    });
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
  }
  function boot() { document.querySelectorAll('[data-tm-chat]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true});
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
